/* Bundle cart: Frame secenegine gercek cerceve gorseli ekler.
   Pill'ler cz-bundle'in kendi JS'i tarafindan olusturuluyor ve
   uzerlerinde deger bilgisi yok; burada etiket metninden okuyup
   data-frame yaziyoruz ki CSS swatch'i eslestirebilsin.
   Boylece 22 KB'lik cz-bundle.liquid'e dokunmuyoruz. */
(function () {
  var FRAMES = { black: 1, espresso: 1, white: 1, natural: 1 };

  function deco() {
    var opts = document.querySelectorAll('.cz-bundle__opt');
    for (var i = 0; i < opts.length; i++) {
      var opt = opts[i];
      var lab = opt.querySelector('.cz-bundle__olabel');
      if (!lab || lab.textContent.trim().toLowerCase() !== 'frame') continue;
      opt.classList.add('cz-bundle__opt--frame');
      var pills = opt.querySelectorAll('.cz-bundle__pill');
      for (var j = 0; j < pills.length; j++) {
        var b = pills[j];
        var v = b.textContent.trim().toLowerCase();
        if (!FRAMES[v]) continue;
        if (b.dataset.frame === v && b.querySelector('.cz-bundle__sw')) continue;
        b.dataset.frame = v;
        if (!b.querySelector('.cz-bundle__sw')) {
          var s = document.createElement('i');
          s.className = 'cz-bundle__sw';
          s.setAttribute('aria-hidden', 'true');
          b.insertBefore(s, b.firstChild);
        }
      }
    }
  }

  function boot() {
    deco();
    var host = document.querySelector('.cz-bundle');
    if (host && window.MutationObserver) {
      new MutationObserver(deco).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
